import { TableRow } from '@mui/material';
import { createTheme, styled } from '@mui/material/styles';

export const CRPTheme = createTheme({
  palette: {
    primary: { main: '#008efd', extraLight: '#f1f3ff' },
    secondary: { main: '#f50057' },
    success: { main: '#4caf50', light: '#f4fff9' },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: '8px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '10px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiBadge: {
      styleOverrides: {
        anchorOriginTopRightRectangular: {
          top: '10px',
        },
      },
    },
  },
});

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.background.default,
  },
}));

export const CRPCompanyTableTheme = createTheme({
  palette: {
    primary: { main: '#008efd' },
    secondary: { main: '#f50057' },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: '8px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '8px',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          marginTop: '10px',
        },
      },
    },
  },
});

export const CRPTableTheme = createTheme({
  palette: {
    primary: { main: '#008efd' },
    secondary: { main: '#f50057' },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: '8px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '0px 10px',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          marginTop: '10px',
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          border: '0 !important',
        },
      },
    },
  },
});

export const CRPExpiredTokenTheme = createTheme({
  components: {
    MuiDialogActions: {
      styleOverrides: {
        root: {
          justifyContent: 'center',
        },
      },
    },
  },
});
